import { Outlet } from "react-router-dom";
import { ExpertSocketProvider } from "../connectivity/chat/ExpertSocketProvider";

export function GlobalChatWrapper() {
  return (
    <ExpertSocketProvider>
      <Outlet />
    </ExpertSocketProvider>
  );
}